/** 翻译开关 localStorage 键，同源多窗口/多标签页通过 storage 事件同步 */
export const FANYI_STORAGE_KEY = "fanyi";

/** 跨标签页同步时派发的自定义事件名 */
export const FANYI_SYNC_EVENT = "rakumart-fanyi-sync";

/**
 * 从 localStorage 读取翻译开关
 * @returns {boolean|null} null 表示未存过
 */
export function readFanyiFromStorage() {
  const raw = localStorage.getItem(FANYI_STORAGE_KEY);
  if (raw === null) return null;
  return raw === "true" || raw === "1";
}

/**
 * 写入翻译开关到 localStorage
 * @param {boolean} value 是否显示中文
 */
export function writeFanyiToStorage(value) {
  localStorage.setItem(FANYI_STORAGE_KEY, value ? "true" : "false");
}

/**
 * 注册 storage 监听：其他窗口改 fanyi 时同步到当前 store
 * @param {import('vuex').Store} store
 */
export function setupFanyiCrossTabSync(store) {
  if (typeof window === "undefined") return;

  window.addEventListener("storage", (e) => {
    if (e.key !== FANYI_STORAGE_KEY || e.newValue === null) return;
    const next = e.newValue === "true" || e.newValue === "1";
    if (store.state.fanyi === next) return;
    store.commit("changeData", next);
    window.dispatchEvent(new CustomEvent(FANYI_SYNC_EVENT));
  });
}

/**
 * 启动时用 localStorage 覆盖 store（优先级高于 sessionStorage 里的 vuex）
 * @param {import('vuex').Store} store
 */
export function hydrateFanyiFromStorage(store) {
  const saved = readFanyiFromStorage();
  if (saved !== null && store.state.fanyi !== saved) {
    store.commit("changeData", saved);
  }
}
